export default "__VITE_ASSET__Bozyg2S7__"